"use client"

import Link from "next/link"
import { useLocalePath } from "@/lib/use-localized-navigation"

/**
 * Renders a quiz CTA that navigates to the in-site `/quiz-focus` funnel.
 *
 * (Previously routed by the concluded `quiz-cta-destination` experiment
 * between the external get.aheadhealth.com quiz and `/quiz-focus`; the
 * internal funnel won, so all quiz CTAs now point there.)
 */
export function QuizCtaLink({
  children,
  className,
  onClick,
  "aria-label": ariaLabel,
}: {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  "aria-label"?: string
}) {
  const lp = useLocalePath()

  return (
    <Link
      href={lp("/quiz-focus")}
      onClick={onClick}
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  )
}
